import React from 'react';
import DrayageQuoteForm from './DrayageQuoteForm';
const DrayageQuotePage = () => {
    return (React.createElement("div", null,
        React.createElement(DrayageQuoteForm, null)));
};
export default DrayageQuotePage;
